module.exports = __webpack_public_path__ + "static/media/HIDRO-WF0972.3215a7e7.pdf";